<template lang="html">
    <div class="d-flex flex-column h-100 position-relative">

        <div class="navigator" style="height: 65px;">
            <h2 class="mr-auto">Promocodes</h2>

            <button class="btn wide" :disabled="accessPermissionFilter(['mainSupervisor'])" @click="createNewPromocode">
                <i class="ico-add large"></i>
                Create New
            </button>
        </div>

        <!-- Lower area -->
        <div class="overflow-auto flexGrow1">

        <!-- white area -->
            <div class="px-3 py-4 d-flex">
                <div class="col-sm-12 bg-lightest">

                    <!-- Filter & search -->
                    <div class="col-sm-12 my-3 pt-4">
                        <div class="row">

                            <div class="col-sm-12">
                                <div class="row">

                                    <div class="d-flex col-sm-4 pl-0">
                                        <div class="d-flex w-100">
                                            <input class="bg-lighter flexGrow1" type="text" v-model="filters.searchString" @input="searchInputChanged" placeholder="Search promocode">
                                            <button class="btn wider blue ml-3 w-80" @click='filter'>Search</button>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="col-sm-12 mt-3">
                                <div class="row">

                                    <div class="col-md-2 d-flex flex-row align-items-center pl-0">
                                        <v-select 
                                            :options="statusFilterList" 
                                            label="label" 
                                            placeholder="All Status" 
                                            v-model="selectedStatusFilter" 
                                            @input="changeStatusFilter">
                                        </v-select>
                                    </div>

                                    <div class="col-md-2 d-flex flex-row align-items-center pl-0">
                                        <v-select 
                                            :options="audienceFilterList" 
                                            label="label" 
                                            placeholder="All Audiences" 
                                            v-model="selectedAudienceFilter" 
                                            @input="changeAudienceFilter">
                                        </v-select>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- Table -->
                    <div v-if="getIsLoadingPromocodes" class="p-4 text-center mb-4">
                        <loader></loader>
                    </div>

                    <div v-else-if="getPromocodes.length == 0" class="text-center dark p-4 mb-4">
                        <span class="">📎 You have no campaigns created yet. <span class="bold underlined pointer" @click="createNewPromocode">Start a new campaign</span>.</span>
                    </div>

                    <div v-else>
                        <!-- Pagination -->
                        <div class="d-flex justify-content-end my-4">
                            <uib-pagination v-if="getPromocodesPagination.pageCount > 1" v-model="currentPagination" :total-items="paginationSettings.totalItems" :items-per-page="paginationSettings.itemsPerPage" :boundary-link-numbers="false" :max-size="7" @change="fetchPromocodes"></uib-pagination>
                        </div>
                        <list :header="header" :body="body" :rows="getPromocodes" :actions="actions" :showNoDataMessage="false"></list>
                        <div class="d-flex justify-content-end my-4">
                            <uib-pagination v-if="getPromocodesPagination.pageCount > 1" v-model="currentPagination" :total-items="paginationSettings.totalItems" :items-per-page="paginationSettings.itemsPerPage" :boundary-link-numbers="false" :max-size="7" @change="fetchPromocodes"></uib-pagination>
                        </div>
                    </div>

                </div>
            </div>

        </div>

    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import vSelect from 'vue-select'
import List from '@/tools/list/baseList'
import {promocodesMixin} from '@/mixins/promocodes'
import Loader from '@/tools/loaders/loader1'

export default {
    mixins:[
        promocodesMixin,
    ],
    data: function () {
        return {
            currentPagination: {
                currentPage: 1,
                numPages:1
            },
            paginationSettings: {
                itemsPerPage: 25,
                totalItems: 0
            },
            filters: {
                searchString: null,
                promocodeStatus: 1,
                promocodeAudience: null,
            },
            selectedStatusFilter: null,
            selectedAudienceFilter: null,
            allStatusFilter:{
                id: null,
                label: 'All Status'
            },
            defaultStatusFilter:{
                id: 1,
                label: 'Active'
            },
            defaultAudienceFilter:{
                id: null,
                label: 'All Audiences'
            },
            actions: {
                label : 'Actions',
                alwaysVisible: true,
                list: [
                    {
                        slug: 'delete',
                        title: 'Delete',
                        tooltip: 'Delete',
                        params: '',
                        class: '',
                        icon: 'ico-delete largest',
                        event: this.setDeletePromocode
                    },
                    {
                        slug: 'pause',
                        title: 'Pause',
                        tooltip: 'Pause',
                        params: '',
                        class: '',
                        icon: 'fas fa-pause largest',
                        event: this.setPausePromocode
                    },
                    {
                        slug: 'publish',
                        title: 'Publish',
                        tooltip: 'Publish',
                        params: '',
                        class: '',
                        icon: 'fas fa-play largest',
                        event: this.setResumePromocode
                    },
                ],
            }
        }
    },
    created: function () {
        this.fetchPromocodes();
        this.setStartingFilters();
        this.initProducts();
    },
    computed: {
        ...mapGetters([
            'getPromocodes',
            'getIsLoadingPromocodes',
            'getPromocodesPagination',
            'getPromocodeStates',
            'getPromocodeAudience',
            'getPromocodeDaysInAdvance',
        ]),
        statusFilterList: function () {
            let output = JSON.parse(JSON.stringify(this.getPromocodeStates))
            output.unshift(this.allStatusFilter);
            return output
        },
        audienceFilterList: function () {
            let output = JSON.parse(JSON.stringify(this.getPromocodeAudience))
            output.unshift(this.defaultAudienceFilter);
            return output
        },
        header: function () {
            let vm = this
            return {
                selection: {
                    active: false,
                    event: function(event) {}
                },
                list: {
                    code: 'Code',
                    audience: 'Audience',
                    validity: 'Validity',
                    products: 'Products',
                    note: 'Note',
                    value: 'Value',
                    usage: 'Usage'
                },
                customClassCell:{
                    // validity: 'w-50',
                    // products: 'w-50',
                }
            };
        },
        body: function() {
            let vm = this;

            return {
                selection: {
                    active: false,
                    event: function(event, row) {}
                },
                customRowEvent: function(row) { vm.viewPromocode(row)},
                customCells: {
                    code: function(row) {
                        let richStatus = vm.promocodeRichStatus(row.status)
                        let output = '<div class="bold">'+row.code+'</div>'
                        if(row.loading && row.loading == true){
                            output += '<div class="loaderHolder"><div class="loader">Loading...</div></div>'
                        } else {
                            output += '<div><span class="px-2 py-0 radius-normal fs-smaller bold '+ 'bg-'+richStatus.color1 + ' '+ richStatus.color2 +'">'+ richStatus.label +'</span></div>'
                        }

                        return output
                    },
                    audience: function(row) {
                        return vm.promocodeRichAudience(row.promocodeType).label
                    },
                    validity: function(row) {
                        return moment(row.bookingPeriodStart).format('YYYY-MM-DD') +' - '+ moment(row.bookingPeriodFinish).format('YYYY-MM-DD')
                    },
                    products: function(row) {
                        if(row.isForAllProducts){
                            return 'All Products'
                        } else {
                            return vm.promocodeProducts(row).join(', ').substring(0,50) + "..."
                        }
                    },
                    note: function(row) {
                        // console.log(row);
                        return row.note ? row.note.substring(0,50) + "..." : ''
                    },
                    value: function(row) {
                        return row.value + (row.amountType == 0? '€':'%')
                    },
                    usage: function(row) {
                        return row.numberOfUses
                    },
                },
                customClassCell: {
                    reservation : 'pointer',
                    created : 'pointer',
                    pax : 'pointer',
                    totalPrice : 'pointer',
                    fullName : 'pointer',
                    seller : 'pointer',
                    status : 'pointer',
                    checkin : 'pointer',
                    noshow : 'pointer',
                },
                // rowEvent: this.view(event),
            }
        },
    },
    methods: {
        ...mapActions([
            'downloadPromocodes',
            'deletePromocode',
            'pausePromocode',
            'resumePromocode',
            'setSelectedPromocode',
            'initProducts',
        ]),
        fetchPromocodes: function () {
            this.downloadPromocodes({
                filters: this.filters,
                paginationSettings: this.paginationSettings,
                currentPage: this.currentPagination.currentPage
            }).then(response => {
                this.paginationSettings.totalItems = response.data.pageInfo.totalItemCount
                this.currentPagination.numPages = response.data.pageInfo.pageCount // Bug? Not updating value, so evaluating it with "v-if="getPromocodesPagination.pageCount > 1"", console.log below - but no worries, it's working now
                // console.log('SUPPOSED TO BE THE SAME VALUE response.data.pageInfo.pageCount, this.currentPagination.numPages :>> ', response.data.pageInfo.pageCount, this.currentPagination.numPages);
            })
        },
        paginationChanged: function (e) {
        },
        createNewPromocode: function () {
            this.$router.push({'name': 'newpromocode'})
        },
        setStartingFilters: function () {
            this.selectedStatusFilter = this.defaultStatusFilter
            this.selectedAudienceFilter = this.defaultAudienceFilter
        },
        changeStatusFilter: function (e) {
            let oldVal = this.filters.promocodeStatus
            this.filters.promocodeStatus = e.id
            let newVal = this.filters.promocodeStatus
            if(newVal != oldVal){
                this.filter()
            }
        },
        changeAudienceFilter: function (e) {
            let oldVal = this.filters.promocodeAudience
            this.filters.promocodeAudience = e.id
            let newVal = this.filters.promocodeAudience
            if(newVal != oldVal){
                this.filter()
            }
        },
        searchInputChanged() {
            this.filter()
        },
        filter: function () {
            this.currentPagination.currentPage = 1 // start at page 1 every time we perform a search / filter
            this.fetchPromocodes(this.filters)
        },
        viewPromocode: function (row) {
            this.setSelectedPromocode(row)
            this.$router.push({name:'editpromocode'})
        },
        setDeletePromocode: function (row) {
            this.$set(row, 'loading', true)
            this.deletePromocode(row).then(response => {
                this.filter()
            })
        },
        setPausePromocode: function (row) {
            this.$set(row, 'loading', true)
            this.pausePromocode(row).then(response => {
                this.filter()
            })
        },
        setResumePromocode: function (row) {
            this.$set(row, 'loading', true)
            this.resumePromocode(row).then(response => {
                this.filter()
            })
        },
    },
    components: {
        vSelect,
        List,
        Loader
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// Promocodes.vue?871f127a